import React from "react";
import { combineReducers, configureStore } from "@reduxjs/toolkit";
import storage from "redux-persist/lib/storage";
import { persistReducer, persistStore } from "redux-persist";
import InsuredReducer from "./InsurerReducer";
import sessionStorage from 'redux-persist/es/storage/session';
import CIReducer from "./CIReducer";
import IntermediaryReducer from "./IntermediaryReducer";

const persistConfig = {
  key: "root",
  storage: sessionStorage,
};

const rootReducer = combineReducers({
  common: InsuredReducer,
  agData : IntermediaryReducer,
  CI:CIReducer
});

const persistedReducer = persistReducer(persistConfig, rootReducer);

export const store = configureStore({
  reducer: persistedReducer,
  devTools: true,
});

export const persistor = persistStore(store);
